import { type SvgIconProps } from '@common/components/svgs/props';

function IconEyeCrossed(
  { size = 16, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
      height={size}
      width={size}
      fill="none"
      data-testid="svg-EyeCrossed"
    >
      <path
        d="M12 19c.946 0 1.81-.103 2.598-.281l-1.757-1.757c-.273.021-.55.038-.84.038-5.352 0-7.425-3.846-7.927-5a8.642 8.642 0 0 1 1.508-2.297L4.184 8.305c-1.538 1.667-2.12 3.346-2.132 3.379a.994.994 0 0 0 0 .633C2.073 12.383 4.367 19 12 19Zm0-14c-1.837 0-3.346.396-4.604.981L3.707 2.293 2.293 3.707l18 18 1.414-1.414-3.319-3.319c2.614-1.951 3.547-4.615 3.561-4.657a.994.994 0 0 0 0-.633C21.927 11.617 19.633 5 12 5Zm4.972 10.558-2.28-2.28c.19-.39.308-.819.308-1.278 0-1.641-1.359-3-3-3-.459 0-.888.118-1.277.309L8.915 7.501A9.26 9.26 0 0 1 12 7c5.351 0 7.424 3.846 7.926 5-.302.692-1.166 2.342-2.954 3.558Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconEyeCrossed.displayName = 'EyeCrossed';

export default IconEyeCrossed;
